import React, { useState } from 'react';

const AdminLogin = ({ onLogin }) => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    // Simple password check - you can change this to any password you want
    if (password === 'Kristiyan24') {
      onLogin(true);
      setError('');
    } else {
      setError('Invalid password');
      setPassword('');
    }
  };

  return (
    <div className="card" style={{ maxWidth: '400px', margin: '2rem auto', textAlign: 'center' }}>
      <h2>Polling Platform Admin</h2>
      <p style={{ color: 'var(--text-light)', marginBottom: '2rem' }}>
        Enter password to access admin panel
      </p>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Enter password"
            style={{ textAlign: 'center' }}
          />
        </div>
        {error && (
          <p style={{ color: 'var(--danger-color)', marginBottom: '1rem' }}>
            {error}
          </p>
        )}
        <button type="submit" className="btn" style={{ width: '100%' }}>
          Access Admin
        </button>
      </form>
    </div>
  );
};

export default AdminLogin;